import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import '@/assets/css/reset.css';
import "./plugins/index"

// swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

// 微信分享
import WXConfig from './plugins/wx.jsapi' // 微信分享
Vue.prototype.WXConfig = WXConfig;

Vue.config.productionTip = false;

new Vue({
    router,
    render: h => h(App)
}).$mount("#app");